export enum Feature {
  PERSONAL_INFO = 'PERSONAL_INFO',
}

export type FeatureFlag = Record<Feature, boolean>;
